export const SUBSCRIBE_LIST_ID = '3592045a39'
export const SUBSCRIBE_URL =
  'https://mc.us16.list-manage.com/subscribe/form-post-json?u=f2d62d11e887c58908e444cd7&popup=true&b_f2d62d11e887c58908e444cd7_3592045a39&c='
